import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import apiService, { handleError } from "../../Common/ApiCommon/ApiService";
import images from "../../../assets/images/constantImages";
import { useNavigate } from "react-router-dom";

const OtpConfirmation = () => {
  const navigate = useNavigate(); // Use the useNavigate hook
  const role = localStorage.getItem("role");

  const validationSchema = Yup.object({
    otp: Yup.string()
      .required("OTP is required")
      .matches(/^[0-9]{4}$/, "OTP must be exactly 4 digits (numbers only)"),
  });

  const apiUrl =
    role === "staff"
      ? "/staff_users/otp_confirmation"
      : role === "vendor" ? "/vendors/otp_confirmation"
        : role === "canteenUser" ? "/canteen_users/otp_confirmation" : "/vendors/otp_confirmation"

  const handleSubmit = async (values, { setSubmitting, setFieldError }) => {
    try {
      const storedId = localStorage.getItem("userId");
      if (!storedId) return toast.error("User ID not found. Please try again.", { duration: 2000 });

      const payload = { id: Number(storedId), otp: values.otp };

      const response = await apiService.post(apiUrl, payload);

      if (response.data?.id && response.data?.email) {
        toast.success(response.message, { duration: 2000 });
        localStorage.setItem("userId", response.data.id.toString());
        localStorage.setItem("role", role);
        setTimeout(() => {
          navigate("/resetPassword");
        }, 100);
      }
    } catch (errors) {
      handleError(errors)
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <div className="w-full bg-green flex justify-center items-center relative">
        <div className="w-full">
          <img
            src={images.loginimage}
            alt="loginimage"
            className="w-full h-screen backdrop-blur-[8px] mix-blend-multiply"
          />
          <div className="absolute top-0 z-10 w-full">
            <img
              src={images.loginclipimage}
              alt=""
              className="w-full h-screen opacity-[8%]"
            />
          </div>
          <div className="absolute sm:right-10 lg:top-8 top-3 right-2">
            <img src={images.logo} alt="logo" className="w-[180px] h-[75px]" />
          </div>
        </div>
        <div className="bg-white rounded-lg w-[320px] xs:w-[430px] shadow-lg p-8 absolute z-30">
          <div className="w-full">
            <h1 className="text-G800 font-bold text-[25px] xs:text-[32px] mb-4">
              OTP Confirmation
            </h1>
            <Formik
              initialValues={{ otp: "" }} // Removed ID from initial values; we'll get it dynamically
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              {({ isSubmitting }) => (
                <Form>
                  <div className="mb-4">
                    <label className="text-[16px] text-G200 mb-2">OTP</label>
                    <Field
                      type="text"
                      name="otp"
                      placeholder="Enter your 4-digit OTP"
                     className="w-full border border-G30 rounded-lg text-G80 p-3 text-sm z-30 outline-none"
                      maxLength="4"
                      onKeyPress={(e) => {
                        if (!/[0-9]/.test(e.key)) {
                          e.preventDefault();
                        }
                      }}
                    />
                    <ErrorMessage
                      name="otp"
                      component="div"
                      className="text-sm text-red"
                    />
                  </div>
                  <button
                    type="submit"
                    className={`w-full py-2 px-4 bg-green text-white rounded-lg shadow-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 ${isSubmitting ? "opacity-50 cursor-not-allowed" : ""
                      }`}
                  >
                    {isSubmitting ? "Verifying..." : "Verify OTP"}
                  </button>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </>
  );
};

export default OtpConfirmation;
